export function handleAutoResize(context, el, fieldname) {
  var h = parseInt(el.style.height, 10);
  var sH = el.scrollHeight + 1; // 1px for border-bottom

  if(isNaN(h)) {
    handleChange(context, fieldname+"_height", sH); // todo: de functie van hier direct gebruiken?
  } else if(h < sH) {
    if(h !== sH) handleChange(context, fieldname+"_height", sH);
  }
}

export function toggleDropdown(context, e, state_name) {
  e = (typeof e !== 'undefined') ? e : null;
  state_name = (typeof state_name !== 'undefined') ? state_name : "dropdown_open";

  e && e.preventDefault();
  toggleState(context, state_name);
}

export function toggleState(context, state_name) {
  var newState = {};
  newState[state_name] = !context.state[state_name];
  context.setState(newState);
}

export function openModal(context, e, content, modal_state_name) {
  e = (typeof e !== 'undefined') ? e : null;
  content = (typeof content !== 'undefined') ? content : null;
  modal_state_name = (typeof modal_state_name !== 'undefined') ? modal_state_name : "modal_open";

  e && e.preventDefault();
  var newState = {};
  newState[modal_state_name] = true;
  newState["modal_content"] = content;
  context.setState(newState);
}

export function closeModal(context, modal_state_name) {
  modal_state_name = (typeof modal_state_name !== 'undefined') ? modal_state_name : "modal_open";

  var newState = {};
  newState[modal_state_name] = false;
  context.setState(newState);
}

export function handleChange(context, state_name, e) {
  var newState = {};
  newState[state_name] = (typeof e.target !== "undefined") ? e.target.value : e;
  context.setState(newState);
}

export function handleSubChange(context, state_name, state_key, state_key_value, e) {
  var newState = {};
  var new_value = (typeof e.target !== "undefined") ? e.target.value : e;
  newState[state_key] = state_key_value;
  newState[state_key][state_name] = new_value;
  context.setState(newState);
}

export function areFieldsNotEmpty(required_fields, payload, setAlert) {
  // todo: i18n
  for(var i = 0; i < required_fields.length; i++) {
    if(payload[required_fields[i].dbcol] === "") {
      setAlert("Veld \""+required_fields[i].name+"\" is verplicht."); // i18n: "Field \""+required_fields[i].name+"\" is required."
      return false;
    }
  }
  return true;
}

export function areFieldsValid(validate_fields, payload, setAlert) {
  // todo: i18n
  for(var i = 0; i < validate_fields.length; i++) {
    if(typeof payload[validate_fields[i].dbcol] === "string" && payload[validate_fields[i].dbcol].indexOf("\\") >= 0) {
      setAlert("Ongeldige tekens gebruikt in veld \""+validate_fields[i].name+"\": \\ .");// i18n: "Used invalid character in field \""+validate_fields[i].name+"\": \\ ."
      return false;
    }
  }
  return true;
}

export function sanitizePayload(validate_fields, payload) {
  for(var i = 0; i < validate_fields.length; i++) {
    if(validate_fields[i].type === "int") {
      payload[validate_fields[i].dbcol] = parseInt(payload[validate_fields[i].dbcol]);
      if(isNaN(payload[validate_fields[i].dbcol])) payload[validate_fields[i].dbcol] = "";
    } else if(validate_fields[i].type === "datetime") {
      var parsed_datetime = new Date(payload[validate_fields[i].dbcol]);
      var now = new Date();
      var utcd = new Date(parsed_datetime.getTime()+(now.getTimezoneOffset()*60000)); // minute offset in milliseconds
      var utc_datetime = utcd.getFullYear()+"-"+(utcd.getMonth()+1)+"-"+utcd.getDate()+" "+utcd.getHours()+":"+utcd.getMinutes();
      payload[validate_fields[i].dbcol] = utc_datetime;
    } else if(payload[validate_fields[i].dbcol].indexOf("'") >= 0) {
      payload[validate_fields[i].dbcol] = payload[validate_fields[i].dbcol].replace(new RegExp("'", 'g'), "\\'");
    }
  }
  return payload;
}

export function handleKeydown(context, e) {
  // console.log("handleKeydown", e.key)
  if(e.ctrlKey) return;
  if(e.key !== "Escape" && e.key !== "n") return;
  if((context.state.modal_create_open || context.state.modal_update_open || context.state.dropdown_open || context.state.modal_open) && e.key !== "Escape") return;
  if((!context.state.modal_create_open && !context.state.modal_update_open && !context.state.dropdown_open && !context.state.modal_open) && e.key === "Escape") return;
  if(document.getElementById("modal-labels-hook") && (e.key !== "Escape")) return;
  if(document.getElementById("modal-form-hook") && (e.key !== "Escape")) return; // probably replace above context.state with hooks in all modals

  e.preventDefault();

  if((context.state.modal_create_open && e.key === "Escape") || (!context.state.modal_create_open && e.key === "n")) {
    toggleState(context, "modal_create_open");
    return;
  }

  if(context.state.modal_update_open && e.key === "Escape") {
    toggleState(context, "modal_update_open");
    return;
  }

  if(context.state.dropdown_open && e.key === "Escape") {
    toggleState(context, "dropdown_open");
    return;
  }

  if(context.state.modal_open && e.key === "Escape") {
    toggleState(context, "modal_open");
    return;
  }
}



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/modules/functions.js
// module id = 924
// module chunks = 0